export default {
  noData: {
    summary: 'No data found',
  },
  noAccess: 'User is missing access',
};
